import DocumentRepository from "../Repository/DocumentRepository";
import getDatabase from "./database";
import ChangeDocumentPosition from "../UseCase/ChangeDocumentPosition";

const changeDocumentPosition: ChangeDocumentPosition = new ChangeDocumentPosition(
    new DocumentRepository(getDatabase())
);

export default function getChangeDocumentPosition(): ChangeDocumentPosition {
    return changeDocumentPosition;
}